<template>
    <table class="table table-responsive-md border border-gray">
        <thead>
            <tr class="bg-table-header">
                <th>First Name</th>
                <th>Last Name</th>
                <th>Role</th>
                <th>Relationship</th>
                <th>Primary Phone</th>
                <th class="text-center">Primary Emergency Contact</th>
                <th class="text-center">Other Emergency Contact</th>
                <th class="text-center">Bereavement Contact</th>
                <th class="text-end">Actions</th>
            </tr>
        </thead>
        <tbody v-if="isLoading || isError || !hasData">
            <!-- LOADING -->
            <template v-if="isLoading">
                <tr v-for="i of loadingCount" :key="i" class="table-loading">
                    <td v-for="i of columns" :key="i">
                        <span class="shimmer-loading"></span>
                    </td>
                </tr>
            </template>
            <!-- EMPTY -->
            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                <td :colspan="columns">
                    <h3>No Contacts Found.</h3>
                </td>
            </tr>
            <!-- ERROR -->
            <tr class="table-error" v-if="!isLoading && isError">
                <td :colspan="columns">
                    <ErrorMessageHandler title="Contact list" :try-again="getContacts" />
                </td>
            </tr>
        </tbody>
        <template v-else>
            <AuthorizedContactsRow
                v-for="(contact, index) of contacts"
                :key="contact"
                :contact="contact"
                :index="index"
                :is-re-order-requested="isReOrderRequested"
                :patient-primary-address="patientPrimaryAddress"
                :columns="columns"
                :patient-id="patientId"
                v-model:total-contacts="totalContacts"
                :relationships-enum="relationshipsEnum"
                :contact-roles-enum="contactRolesEnum"
                :refresh-list="getContacts"
                :move-up="moveUp"
                :move-down="moveDown"
                :update-contact="updateAuthorizedContact"
                :delete-authorized-contact="deleteAuthorizedContact"
            />
        </template>
    </table>
</template>

<script lang="ts" src="./AuthorizedContactsList.ts"></script>
